module.exports = __webpack_public_path__ + "static/media/YF75_04.f75ab44d.jpg";